var _require = require('./helpers'),
  isP2shPublicKey = _require.isP2shPublicKey,
  listRustP2shInputIndexes = _require.listRustP2shInputIndexes;
function logFulfillment(_stage, _message) {
  var _data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
}
function summarizeSlipForApp(app, slip) {
  var _slip$amount, _slip$blockId, _slip$txOrdinal;
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!slip) {
    return null;
  }
  return {
    index: index,
    type: slip.type,
    publicKey: slip.publicKey || '',
    amount: String((_slip$amount = slip.amount) !== null && _slip$amount !== void 0 ? _slip$amount : 0),
    blockId: String((_slip$blockId = slip.blockId) !== null && _slip$blockId !== void 0 ? _slip$blockId : 0),
    txOrdinal: String((_slip$txOrdinal = slip.txOrdinal) !== null && _slip$txOrdinal !== void 0 ? _slip$txOrdinal : 0),
    utxoKey: slip.utxoKey || '',
    p2sh: isP2shPublicKey(app, slip.publicKey || '')
  };
}
function summarizeOrder(order) {
  var _order$price, _order$quantity, _order$payment_output, _order$payment_amount, _order$attempts;
  if (!order) {
    return null;
  }
  return {
    id: order.id,
    order_tx_sig: order.order_tx_sig || order.signature || '',
    buyer: order.buyer || '',
    nft_id: order.nft_id || '',
    price: Number((_order$price = order.price) !== null && _order$price !== void 0 ? _order$price : 0),
    quantity: Number((_order$quantity = order.quantity) !== null && _order$quantity !== void 0 ? _order$quantity : 1),
    payment_tx_sig: order.payment_tx_sig || '',
    payment_output_index: Number((_order$payment_output = order.payment_output_index) !== null && _order$payment_output !== void 0 ? _order$payment_output : 0),
    payment_amount: Number((_order$payment_amount = order.payment_amount) !== null && _order$payment_amount !== void 0 ? _order$payment_amount : 0),
    access_hash: order.access_hash || '',
    p2sh_address: order.p2sh_address || '',
    has_access_script: Boolean(order.access_script),
    status: order.status || '',
    attempts: Number((_order$attempts = order.attempts) !== null && _order$attempts !== void 0 ? _order$attempts : 0)
  };
}
function listP2shInputIndexes(app, tx) {
  return listRustP2shInputIndexes(app, tx);
}
function dumpP2shScriptEngineCall() {}
function dumpFulfillmentAccessScripts() {}
function logAccessScriptsForP2sh() {}
module.exports = {
  logFulfillment: logFulfillment,
  summarizeOrder: summarizeOrder,
  summarizeSlipForApp: summarizeSlipForApp,
  listP2shInputIndexes: listP2shInputIndexes,
  logAccessScriptsForP2sh: logAccessScriptsForP2sh,
  dumpFulfillmentAccessScripts: dumpFulfillmentAccessScripts,
  dumpP2shScriptEngineCall: dumpP2shScriptEngineCall
};